// extracted by mini-css-extract-plugin
export var errorsContainer = "_qu-1";
export var link = "_qu-0";